import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: theme.palette.base.offWhite,
  },
}));

export const StyledAppBar = styled(AppBar)({
  position: 'relative',
  height: '56px',
  backgroundColor: '#FFFFFF',
  boxShadow: '1px 3px 4px rgba(0, 0, 0, 0.2)',
});

export const StyledToolbar = styled(Toolbar)({
  display: 'flex',
  height: '56px',
  minHeight: '56px !important',
  padding: '0 24px',
  boxSizing: 'border-box',
  alignItems: 'center',
});

export const StyledTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 400,
  color: '#0E0D16',
  flex: 1,
});
